import { $host } from './index';
import { ENDPOINTS } from '../constants/endpoints';
import { persistor } from '../redux/store';
import { getCart } from '../http/cart';

export const signIn =
  ({ email, password }) =>
  async (dispatch, getState) => {
    try {
      const {
        data: { access_token }
      } = await $host.post(ENDPOINTS.AUTH.LOGIN, { email, password });
      localStorage.setItem('authorization', access_token);
      const { data } = await $host.get(ENDPOINTS.USER.INFO);
      dispatch({ type: 'User/SET', payload: data });

      const cart = getState().games.cart;
      if (cart.length !== 0) {
        for (let product of cart) {
          await $host.post(ENDPOINTS.CART.ADD, {
            denominationId: product.denominationId,
            quantity: product.quantity
          });
        }
      }
      await dispatch(getCart());

      return data;
    } catch (error) {
      console.log(error);
      throw error?.response?.data;
    }
  };

export const signUp =
  (body) =>
  async (dispatch) => {
    try {
      const {
        data: { access_token }
      } = await $host.post(ENDPOINTS.AUTH.REGISTER, body);
      localStorage.setItem('authorization', access_token);
      await $host.post(ENDPOINTS.AUTH.SEND_EMAIL);
    } catch (error) {
      console.log(error);
      throw error?.response?.data;
    }
  };

export const logout = () => (dispatch) => {
  localStorage.removeItem('authorization');
  dispatch({ type: 'Cart/RESET' });
  dispatch({ type: 'User/RESET' });
  persistor.purge();
};

export const confirmEmail = (code) => async (dispatch) => {
  try {
    const {
      data: { access_token }
    } = await $host.post(ENDPOINTS.AUTH.CONFIRM_EMAIL, { code });
    localStorage.setItem('authorization', access_token);
    const { data } = await $host.get(ENDPOINTS.USER.INFO);
    dispatch({ type: 'User/SET', payload: data });
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  }
};

export const requestEmailReset = (email) => async (dispatch) => {
  try {
    await $host.post(ENDPOINTS.AUTH.REQUEST_PASSWORD_RESET, { email });
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  }
};

export const confirmEmailReset = (token) => async (dispatch) => {
  try {
    dispatch({ type: 'App/SET_ACTIVITY', payload: true });
    await $host.post(ENDPOINTS.AUTH.CONFIRM_PASSWORD_RESET, { token });
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  } finally {
    dispatch({ type: 'App/SET_ACTIVITY', payload: false });
  }
};

export const changePassword = async (oldPassword, password) => {
  try {
    await $host.post(ENDPOINTS.USER.CHANGE_PASSWORD, {
      currentPassword: oldPassword,
      newPassword: password
    });
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  }
};

export const updateMarketConsent = (consent) => async (dispatch) => {
  try {
    dispatch({ type: 'App/SET_ACTIVITY', payload: true });
    await $host.patch(ENDPOINTS.USER.UPDATE, { marketing_consent: consent });
    dispatch({ type: 'User/SET_MARKET_CONSENT', payload: consent });
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  } finally {
    dispatch({ type: 'App/SET_ACTIVITY', payload: false });
  }
};

export const updateLanguage = (language) => async (dispatch) => {
  try {
    dispatch({ type: 'App/SET_ACTIVITY', payload: true });
    await $host.patch(ENDPOINTS.USER.UPDATE, { language });
    dispatch({ type: 'User/SET_LANGUAGE', payload: language });
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  } finally {
    dispatch({ type: 'App/SET_ACTIVITY', payload: false });
  }
};

export const updateAddress = (address) => async (dispatch) => {
  try {
    dispatch({ type: 'App/SET_ACTIVITY', payload: true });
    await $host.patch(ENDPOINTS.USER.UPDATE, address);
    dispatch({ type: 'User/UPDATE', payload: address });
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  } finally {
    dispatch({ type: 'App/SET_ACTIVITY', payload: false });
  }
};
